import RPC from 'api';
import { types, createAction } from './action';
import { setAdvanceState, setCurKey, setPanelArr, setRouteKeepAlive } from 'publicStore/base/public/action';
// 根据类型和数据发送action
function dispatchAction (dispatch, type, data) {
    dispatch(createAction(type, data));
}

/**
 * 功能入口，获取页面初始需要的所有RPC数据传入reducer处理数据
 * 可以重复调用，刷新一般调用init
 */
const init = () => (dispatch, getState, resolve, reject) => {
};

/**
 * 从VM数据够着需要下发的RPC数据，把下发的结果返回给页面显示
 */
const save = () => (dispatch, getState, resolve, reject) => {
    // 构造RPC数据
    dispatchAction(dispatch, types.ADVANCEVERIFY_SAVE);
    // 取出RPC数据
    const rpcData = getState().AdvanceVerify.rpc;
    // 下发RPC数据
    return Promise.all([RPC.ConfigManager.setConfig('Language', rpcData.Language)])
        .then(() => {
            resolve();
        })
        .catch(() => {
            reject();
        });
};

/**
 * 关闭后调用改接口清除所有数据，避免内存堆积
 */
const clear = () => (dispatch) => {
    dispatchAction(dispatch, types.ADVANCEVERIFY_CLEAR);
};

/**
 * 页面取消按钮调用，内部用保存的RPC数据恢复，但保留页面的一些展开收起状态
 */
const cancel = () => (dispatch) => {
    dispatchAction(dispatch, types.ADVANCEVERIFY_CANCEL);
};

export const getDescript = (params) => (dispatch, getState, resolve, reject) => {
    return RPC.ThermographyManager.getDescript(params)
        .then((res) => {
            dispatchAction(dispatch, types.MACHINESET_GETDESCRIPT, res.QRCode);
            resolve();
        }).catch(() => {
            reject();
        });
};

export const checkAuthCode = (params) => (dispatch, getState, resolve, reject) => {
    return RPC.ThermographyManager.checkAuthCode(params)
        .then((res) => {
            dispatchAction(dispatch, types.MACHINESET_CHECKAUTHCODE, res.RetCode);
            resolve();
        }).catch(() => {
            reject();
        });
};

export const userNameChange = (value) => (dispatch) => {
    dispatchAction(dispatch, types.MACHINESET_USERNAME, value);
};

export const dynamicVerifyChange = (value) => (dispatch) => {
    dispatchAction(dispatch, types.MACHINESET_DYNAMICVERIFYCODE, value);
};

/**
 * 刷新没有特殊要求的可以调用init接口，要求init接口可以支持重复调用
 * init无法多次调用的，重新实现
 */
const refresh = init;

//是否为工厂模式
export const getFactoryMode = () => (dispatch, getState, resolve, reject) => {
    RPC.ThermographyManager.getFactoryMode().then(json => {
        resolve(json);
    }).catch(() => {
        reject(false);
    });
};

// 对外暴露，提供给页面使用
export {
    init,
    clear,
    cancel,
    save,
    refresh,
    // 以上是固定接口,
    // 下面定义功能抽象接口
    setAdvanceState,
    setCurKey,
    setPanelArr,
    setRouteKeepAlive,
};
